import { getInstanceId } from '@va/dashboard/selectors/app';
import { getWebsiteCountryISO, getWebsiteUrl } from '@va/dashboard/selectors/core';
import { useLocale } from '@va/localization';
import { toQueryString } from '@va/util/helpers';
import { useSelector } from 'react-redux';

export function useTypo3Parameters() {
  const websiteId = useSelector(getInstanceId);
  const websiteUrl = useSelector(getWebsiteUrl);
  const { locale } = useLocale();
  const geolocation = useSelector(getWebsiteCountryISO);

  return toQueryString({
    websiteId: websiteId,
    domain: websiteUrl,
    locale: locale,
    geolocation: geolocation,
  });
}
